module.exports = __webpack_public_path__ + "static/media/template-1.f05aec2f.png";